import { ADMIN_ROUTES, NOT_AUTHORIZED_ROUTES, PROTECTED_ROUTES, PUBLIC_ROUTES } from '../routes'
import { isRouteAvailable } from '../utils/utils'

export const getRouteAccessState = (pathname) => ({
  isProtectedRoute: isRouteAvailable(PROTECTED_ROUTES, pathname),
  isNotAuthorizedRoute: isRouteAvailable(NOT_AUTHORIZED_ROUTES, pathname),
  isPublicRoute: isRouteAvailable(PUBLIC_ROUTES, pathname),
  isAdminRoute: isRouteAvailable(ADMIN_ROUTES, pathname),
})

export const resolveBootstrapNavigation = ({
  pathname,
  token,
  isProtectedRoute,
  isNotAuthorizedRoute,
  isPublicRoute,
  isAdminRoute,
  decodedToken,
}) => {
  if (isPublicRoute) {
    return {
      redirectTo: null,
      shouldLogoutIntercom: false,
      shouldRestoreSession: Boolean(token),
    }
  }

  if (!token && (isProtectedRoute || pathname === '/')) {
    return {
      redirectTo: '/auth',
      shouldLogoutIntercom: true,
      shouldRestoreSession: false,
    }
  }

  if (token && (isNotAuthorizedRoute || pathname === '/')) {
    return {
      redirectTo: '/games',
      shouldLogoutIntercom: false,
      shouldRestoreSession: true,
    }
  }

  if (isAdminRoute) {
    if (!token) {
      return {
        redirectTo: '/games',
        shouldLogoutIntercom: false,
        shouldRestoreSession: false,
      }
    }

    if (decodedToken?.role !== 'Admin') {
      return {
        redirectTo: '/games',
        shouldLogoutIntercom: false,
        shouldRestoreSession: true,
      }
    }
  }

  return {
    redirectTo: null,
    shouldLogoutIntercom: false,
    shouldRestoreSession: Boolean(token),
  }
}
